// extracted by mini-css-extract-plugin
export default {"FeeEarnerBulkUpdate":"styles_FeeEarnerBulkUpdate__7P4hn","assignButton":"styles_assignButton__oUuu9","selectFeeEarners":"styles_selectFeeEarners__vKqSk"};